import { Injectable } from '@angular/core';
import { select, Store, Action } from '@ngrx/store';

import * as fromApp from './app.reducer';
import * as AppSelectors from './app.selectors';
import * as AppActions from './app.actions';

@Injectable()
export class AppFacade {
  appState$ = this.store.pipe(select(AppSelectors.getAppState));
  loading$ = this.store.pipe(select(AppSelectors.getAppLoading));
  error$ = this.store.pipe(select(AppSelectors.getAppError));
  allLayouts$ = this.store.pipe(select(AppSelectors.getAllLayouts));
  selectedLayout$ = this.store.pipe(select(AppSelectors.getSelectedLayout));

  constructor(private store: Store<fromApp.AppPartialState>) {}

  dispatch(action: Action) {
    this.store.dispatch(action);
  }

  selectLayout(layoutName: string) {
    this.dispatch(AppActions.selectLayout({ layout: layoutName }));
  }
}
